import { Check, BookOpen, Heart, Star } from 'lucide-react';

interface Message {
  id: number;
  text: string;
  time: string;
  isAuthor?: boolean;
}

interface Conversation {
  id: number;
  username: string;
  profilePic: string;
  messages: Message[];
  date: string;
}

interface InstagramTestimonialsProps {
  onOrderClick: () => void;
}

export function InstagramTestimonials({ onOrderClick }: InstagramTestimonialsProps) {
  const conversations: Conversation[] = [
    {
      id: 1,
      username: "andrei.popovici",
      profilePic: "https://images.unsplash.com/photo-1519085360753-af0119f7cbe7?w=150&h=150&auto=format&fit=crop&crop=faces",
      date: "Acum o oră",
      messages: [
        {
          id: 1,
          text: "Am citit cartea într-o noapte. Nu am putut să o las jos. Capitolul despre anxietatea socială m-a lovit direct în suflet...",
          time: "23:15"
        },
        {
          id: 2,
          isAuthor: true,
          text: "Mă bucur că te-ai regăsit în ea. Știu cât de paralizantă poate fi anxietatea socială...",
          time: "23:17"
        },
        {
          id: 3,
          text: "Da, și tehnicile tale de 'reframing' chiar funcționează. Am început să văd interacțiunile sociale ca oportunități, nu amenințări",
          time: "23:19"
        }
      ]
    },
    {
      id: 2,
      username: "maria.dumitrescu",
      profilePic: "https://images.unsplash.com/photo-1534528741775-53994a69daeb?w=150&h=150&auto=format&fit=crop&crop=faces",
      date: "Acum 4 ore",
      messages: [
        {
          id: 1,
          text: "După un burnout sever și 6 luni de depresie, cartea ta a fost ca o lumină la capătul tunelului",
          time: "20:30"
        },
        {
          id: 2,
          isAuthor: true,
          text: "Maria, mă bucur din suflet să aud asta. Burnout-ul e atât de des întâlnit și totuși atât de puțin înțeles...",
          time: "20:32"
        },
        {
          id: 3,
          text: "Exact! Și cel mai tare e că exercițiile tale m-au ajutat să-mi recapăt energia și motivația. Acum știu să pun boundaries la job 🙏",
          time: "20:34"
        }
      ]
    },
    {
      id: 3,
      username: "victor.stanciu",
      profilePic: "https://images.unsplash.com/photo-1507003211169-0a1dd7228f2d?w=150&h=150&auto=format&fit=crop&crop=faces",
      date: "Ieri",
      messages: [
        {
          id: 1,
          text: "Fratele meu a trecut prin depresie severă anul trecut. I-am dat cartea ta și pentru prima dată a simțit că cineva îl înțelege cu adevărat",
          time: "15:20"
        },
        {
          id: 2,
          isAuthor: true,
          text: "Asta înseamnă enorm pentru mine. Cum se simte acum?",
          time: "15:22"
        },
        {
          id: 3,
          text: "Mult mai bine! Folosește zilnic tehnicile din carte și văd o schimbare uriașă în atitudinea lui. În sfârșit văd speranță în ochii lui",
          time: "15:25"
        }
      ]
    },
    {
      id: 4,
      username: "laura.vasilescu",
      profilePic: "https://images.unsplash.com/photo-1531123897727-8f129e1688ce?w=150&h=150&auto=format&fit=crop&crop=faces",
      date: "Acum 2 zile",
      messages: [
        {
          id: 1,
          text: "Am fost sceptică la început pentru că am încercat multe 'soluții miracle' pentru depresie. Dar abordarea ta e complet diferită",
          time: "09:45"
        },
        {
          id: 2,
          isAuthor: true,
          text: "Înțeleg scepticismul. Care parte te-a convins până la urmă?",
          time: "09:47"
        },
        {
          id: 3,
          text: "Faptul că nu promiți vindecări peste noapte, ci oferi unelte practice și recunoști că e un proces. Plus, se simte că ai trecut și tu prin asta",
          time: "09:50"
        }
      ]
    },
    {
      id: 5,
      username: "diana.muresan",
      profilePic: "https://images.unsplash.com/photo-1494790108377-be9c29b29330?w=150&h=150&auto=format&fit=crop&crop=faces",
      date: "Acum 2 ore",
      messages: [
        {
          id: 1,
          text: "Nu-mi vine să cred că în sfârșit am găsit ceva care să mă ajute cu adevărat... Am plâns citind capitolul despre auto-compasiune",
          time: "19:14"
        },
        {
          id: 2,
          isAuthor: true,
          text: "Diana, mă bucur enorm să aud asta. Știu cât de greu e să faci primul pas...",
          time: "19:15"
        },
        {
          id: 3,
          text: "Da... După 2 ani de terapie, cartea ta mi-a dat în sfârșit speranța că pot să transform depresia în ceva pozitiv. Mulțumesc că ai avut curajul să împărtășești povestea ta 🙏",
          time: "19:17"
        }
      ]
    },
    {
      id: 6,
      username: "radu.stefan92",
      profilePic: "https://images.unsplash.com/photo-1500648767791-00dcc994a43e?w=150&h=150&auto=format&fit=crop&crop=faces",
      date: "Ieri",
      messages: [
        {
          id: 1,
          text: "Băi frate, trebuie să-ți zic ceva. Eram super sceptic la început, credeam că e încă o carte de 'gândește pozitiv' și atât...",
          time: "22:45"
        },
        {
          id: 2,
          text: "Dar exercițiile alea de mindfulness + sistemul tău de tracking al stării... efectiv mi-au schimbat perspectiva complet. Prima dată în 5 ani când simt că am control",
          time: "22:46"
        },
        {
          id: 3,
          isAuthor: true,
          text: "Radu, fix asta am vrut să ofer - instrumente practice, nu doar teorie. Mă bucur enorm că te ajută! 💪",
          time: "22:48"
        }
      ]
    },
    {
      id: 7,
      username: "alexandra.pop",
      profilePic: "https://images.unsplash.com/photo-1438761681033-6461ffad8d80?w=150&h=150&auto=format&fit=crop&crop=faces",
      date: "Acum 3 zile",
      messages: [
        {
          id: 1,
          text: "Am terminat cartea aseară și am plâns... dar în sensul bun. Pentru prima dată simt că cineva chiar înțelege cum e să trăiești cu depresia zi de zi",
          time: "23:22"
        },
        {
          id: 2,
          isAuthor: true,
          text: "Alexandra, știu exact ce vrei să spui. De asta am și scris cartea - să arăt că nu suntem singuri în lupta asta ❤️",
          time: "23:24"
        },
        {
          id: 3,
          text: "Cel mai mult m-a ajutat partea cu transformarea narativului negativ. Azi am avut prima zi când m-am trezit și nu m-am urât instant... e un început",
          time: "23:25"
        }
      ]
    },
    {
      id: 8,
      username: "mihai.ionescu84",
      profilePic: "https://images.unsplash.com/photo-1472099645785-5658abf4ff4e?w=150&h=150&auto=format&fit=crop&crop=faces",
      date: "Săptămâna trecută",
      messages: [
        {
          id: 1,
          text: "Salut! Voiam să-ți mulțumesc. Am fost diagnosticat cu depresie acum 3 ani și am încercat tot ce se putea - medicamente, terapie, sport...",
          time: "10:15"
        },
        {
          id: 2,
          text: "Cartea ta mi-a arătat că depresia nu trebuie să fie dușmanul meu. Acum o văd ca pe un semnal că trebuie să fac schimbări în viață",
          time: "10:16"
        },
        {
          id: 3,
          isAuthor: true,
          text: "Exact! Când începi să vezi depresia ca pe un profesor dur dar înțelept, totul se schimbă. Sunt mândru de progresul tău! 🙌",
          time: "10:18"
        }
      ]
    },
    {
      id: 9,
      username: "cristina.vasile",
      profilePic: "https://images.unsplash.com/photo-1544005313-94ddf0286df2?w=150&h=150&auto=format&fit=crop&crop=faces",
      date: "Acum 2 săptămâni",
      messages: [
        {
          id: 1,
          text: "Nu pot să cred că am așteptat atât să comand cartea... Am citit-o în 2 zile. Tehnicile de self-care și rutina de dimineață au fost game-changer pentru mine",
          time: "15:30"
        },
        {
          id: 2,
          isAuthor: true,
          text: "Mă bucur mult să aud asta! Rutina e într-adevăr crucială când vine vorba de gestionarea depresiei",
          time: "15:32"
        },
        {
          id: 3,
          text: "Da! Și apreciez mult că ai inclus și partea cu relațiile toxice și cum să pui boundaries. Asta chiar m-a ajutat să fac niște schimbări necesare în viața mea",
          time: "15:34"
        }
      ]
    }
  ];

  return (
    <section className="py-16 sm:py-24 bg-black/50 px-4 sm:px-6">
      <div className="container mx-auto max-w-7xl">
        <h2 className="text-3xl sm:text-4xl font-bold text-center mb-4 bg-gradient-to-r from-white to-white/90 bg-clip-text text-transparent">
          Mesaje de la Cititori
        </h2>
        
        <div className="text-center mb-12 space-y-4">
          <p className="text-gray-300 max-w-3xl mx-auto text-sm sm:text-base">
            Alătură-te celor peste <span className="text-red-500 font-semibold">10,000+ de cititori</span> care au descoperit cum să transforme depresia într-o superputere
          </p>
          <div className="flex items-center justify-center gap-2 text-sm text-gray-400">
            <Star className="w-4 h-4 text-yellow-500" />
            <span>4.9/5 rating mediu din 500+ review-uri</span>
          </div>
          <div className="flex items-center justify-center gap-2 text-sm text-gray-400">
            <Heart className="w-4 h-4 text-red-500" />
            <span>98% dintre cititori raportează îmbunătățiri semnificative</span>
          </div>
        </div>
        
        <div className="grid grid-cols-1 md:grid-cols-3 gap-6 max-w-6xl mx-auto">
          {conversations.map((conversation) => (
            <div key={conversation.id} className="w-full bg-[#1a1a1a] rounded-xl overflow-hidden border border-gray-800 shadow-xl">
              {/* Instagram-style header */}
              <div className="flex items-center gap-3 p-3 sm:p-4 border-b border-gray-800">
                <img
                  src={conversation.profilePic}
                  alt={conversation.username}
                  className="w-8 h-8 rounded-full object-cover"
                />
                <div>
                  <p className="font-semibold text-white text-sm sm:text-base">{conversation.username}</p>
                  <p className="text-xs text-gray-400">{conversation.date}</p>
                </div>
              </div>

              {/* Messages */}
              <div className="p-3 sm:p-4 space-y-3 min-h-[300px] max-h-[300px] overflow-y-auto bg-gradient-to-b from-black/20 to-transparent">
                {conversation.messages.map((message) => (
                  <div
                    key={message.id}
                    className={`flex ${message.isAuthor ? 'justify-end' : 'justify-start'}`}
                  >
                    <div
                      className={`max-w-[80%] rounded-2xl px-3 sm:px-4 py-2 ${
                        message.isAuthor
                          ? 'bg-[#0095F6] text-white'
                          : 'bg-[#262626] text-gray-100'
                      }`}
                    >
                      <p className="text-sm sm:text-base">{message.text}</p>
                      <div className="flex items-center justify-end gap-1 mt-1">
                        <span className="text-xs opacity-60">{message.time}</span>
                        {message.isAuthor && <Check className="w-3 h-3 opacity-60" />}
                      </div>
                    </div>
                  </div>
                ))}
              </div>
            </div>
          ))}
        </div>

        {/* FOMO Section */}
        <div className="mt-12 mb-8 text-center">
          <div className="inline-block bg-gradient-to-r from-red-900/20 to-black/40 backdrop-blur-sm rounded-xl border border-red-500/20 p-4">
            <p className="text-red-500 font-semibold animate-pulse">
              ⚠️ Atenție: Stoc limitat disponibil la preț promoțional!
            </p>
          </div>
        </div>

        {/* Order Button */}
        <div className="mt-8 text-center">
          <button 
            onClick={onOrderClick}
            className="inline-flex items-center justify-center gap-2 bg-gradient-to-r from-red-600 to-red-700 text-white text-base sm:text-lg px-6 sm:px-8 py-2 sm:py-3 rounded-full font-bold transform transition-all duration-500 hover:scale-105 shadow-[0_0_30px_rgba(239,68,68,0.3)] hover:shadow-[0_0_50px_rgba(239,68,68,0.5)]"
          >
            <span>TRANSFORMĂ-ȚI VIAȚA ACUM</span> <BookOpen className="w-5 h-5" />
          </button>
          <p className="mt-4 text-sm text-gray-400">
            Livrare rapidă în 24-48h • Garanție 30 zile • Suport dedicat
          </p>
        </div>
      </div>
    </section>
  );
}
